/**
 * Created by Анжелика on 23.08.2017.
 */
import * as actionTypes from '../constants/actionTypes';
import * as cookieParams from '../constants/cookies';
import Cookies from 'js-cookie';
import update from "react-addons-update";

const initialState = {
    isFetching: false,
    error: null,
    data: null,
    isActive: false,
    isActivityFetching: false,
    config: null
};

export function userData(state = initialState, action) {
    switch (action.type) {
        case actionTypes.GET_USER_DATA_REQUEST:
            return {
                ...state,
                isFetching: true,
                data: null,
                error: null
            };

        case actionTypes.GET_USER_DATA_SUCCESS:
            return {
                ...state,
                isFetching: false,
                data: action.data,
                error: null
            };

        case actionTypes.GET_USER_DATA_FAILED:
            return {
                ...state,
                isFetching: false,
                data: null,
                error: action.error
            };

        case actionTypes.USER_DATA_CLEAR:
            return {
                ...state,
                data: null
            };

        case actionTypes.SAVE_USER_CONFIG:
            const configItem = {
                userID: action.userID,
                activeChannel: action.activeChannel,
                channelCards: action.channelCards
            };
            _updateUserConfig(configItem);
            return {
                ...state,
                config: configItem
            };

        case actionTypes.LOAD_USER_CONFIG:
            return {
                ...state,
                config: _getUserConfig(action.userID, action.channels)
            };

        case actionTypes.UPDATE_USER_ACTIVITY_REQUEST:
            return {
                ...state,
                isActivityFetching: true,
                isActive: false
            };

        case actionTypes.UPDATE_USER_ACTIVITY_SUCCESS:
            return {
                ...state,
                isActivityFetching: false,
                isActive: true
            };

        case actionTypes.UPDATE_USER_ACTIVITY_FAILED:
            return {
                ...state,
                isActivityFetching: false,
                isActive: false
            };

        case actionTypes.START_SEND_USER_ACTIVITY:
        case actionTypes.STOP_SEND_USER_ACTIVITY:
        default:
            return state;
    }
}

function _updateUserConfig(configItem) {
    const userID = configItem.userID;
    const item = {
        ...configItem,
        activeChannel: configItem.activeChannel ? configItem.activeChannel.channelID : null,
        channelCards: configItem.channelCards ?
            configItem.channelCards.reduce((arr, item) => (
                [...arr, item.channelID]
            ), [])
            : []
    };

    let configItemsUpdated = [item];
    let configItemsStored = Cookies.get(cookieParams.USER_CONFIG);
    if (configItemsStored !== undefined) {
        configItemsStored = JSON.parse(configItemsStored);
        let itemIndex = configItemsStored.findIndex(item => (item.userID === userID));
        if (itemIndex !== -1) {
            configItemsUpdated = update(configItemsStored, {
                $splice: [[itemIndex, 1, item]]
            });
        } else {
            configItemsUpdated = [...configItemsStored, item];
        }
    }
    Cookies.set(cookieParams.USER_CONFIG, configItemsUpdated, cookieParams.cookieOptions);
}

function _getUserConfig(userID, channels) {
    let stored = Cookies.get(cookieParams.USER_CONFIG);
    if (stored !== undefined) {
        stored = JSON.parse(stored);
        let storedItem = stored.find(item => (item.userID === userID));
        if (storedItem) {
            return {
                ...storedItem,
                activeChannel: storedItem.activeChannel ?
                    channels.find(item => (item.channelID === storedItem.activeChannel))
                    : null,

                channelCards: storedItem.channelCards ?
                    storedItem.channelCards.reduce((arr, item) => (
                        [...arr, channels.find(channel => (channel.channelID === item))]
                    ), [])
                    : []
            };
        }
    }
    return null;
}


// WEBPACK FOOTER //
// ./src/reducers/userData.js